import { useListContext, useStore } from "ra-core";
import { useEffect } from "react";

/**
 * Shows these filters in the top bar the first time a list opens. Afterwards
 * the filters the user added or removed are kept (with the list's settings).
 */
export const InitialDisplayedFilters = ({ sources }: { sources: string[] }) => {
  const { resource, displayedFilters, filterValues, setFilters } =
    useListContext();
  const [isDone, setDone] = useStore(`${resource}.initialFilters`, false);

  useEffect(() => {
    if (isDone) return;
    setDone(true);
    if (Object.keys(displayedFilters ?? {}).length > 0) return;
    setFilters(
      filterValues ?? {},
      Object.fromEntries(sources.map((source) => [source, true])),
      false,
    );
  }, [isDone, setDone, displayedFilters, filterValues, setFilters, sources]);

  return null;
};
